<template>
	<component
		:is="isArticle ? 'article' : 'div'"
		class="shadow-lg rounded bg-white"
	>
		<slot />
	</component>
</template>

<script lang="ts" setup>
defineProps<{
	isArticle?: boolean;
}>();
</script>
